export default __webpack_public_path__ + "static/media/eBike1.52b5255a.png";